import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Account } from "../../../../pages/account/account";
import { Objects } from "../../../util/objects";

@Component({
  selector: "ngx-request-confirm-column",
  template: `
    <button *ngIf="account.admin === 'USER' && !data.confirmed" nbButton size="tiny" (click)="saveConfirmed()">
      확인
    </button>
    <span *ngIf="data.confirmed !== false">확인완료</span>
    <span *ngIf="account.admin === 'ADMIN' && data.confirmed === false">-</span>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class RequestConfirmComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  public data: any;
  public account: any;

  constructor() { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.account = Objects.safeGetValue(this.params, 'account', new Account());
  }

  ngOnInit() { }

  saveConfirmed(): void {
    this.params.context.saveConfirmed(this.data);
  }
  
}
